<section class="px-4">
  <div class="notice-header-container">
    <div class="notice-title-container  p-2">
      <button class="back_icon backArrowContainerStyle me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h2 translate class="notice-title">Notice Board</h2>
    </div>
    <div class="d-flex gap-2">
      <button
        mat-stroked-button
        (click)="toggleReorderMode()"
        [disabled]="isLoading"
        class="stroked_button"
      >
        <mat-icon *ngIf="!isLoading">{{
          reorderMode ?"check" : "format_line_spacing"
        }}</mat-icon>
        <span *ngIf="!isLoading">{{
          reorderMode ? ("Submit" | translatepipe) : ("Re-Order" | translatepipe)
        }}</span>
        <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
      </button>

     <button class="add_button" mat-button (click)="openUploadDialog()">
        <i class="fa-solid fa-plus"></i>
        <span translate>Add Notice Board</span>
      </button>
    </div>
  </div>
  <div class="table-container p-2">
    <table
      mat-table
      [dataSource]="noticeboardData"
      class="mat-elevation-z8"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      <ng-container matColumnDef="drag">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="reorderMode">
            <mat-icon class="drag-handle" cdkDragHandle
              >drag_indicator</mat-icon
            >
          </ng-container>
        </td>
      </ng-container>
      <!-- Serial Number -->
      <ng-container matColumnDef="sl.no">
        <th translate mat-header-cell *matHeaderCellDef>Sl. No.</th>
        <td mat-cell *matCellDef="let element">{{ element.sequence }}</td>
      </ng-container>
      <!-- Upload Date Column -->
      <ng-container matColumnDef="visible_from">
        <th translate mat-header-cell *matHeaderCellDef>From Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.visible_from | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="visible_until">
        <th translate mat-header-cell *matHeaderCellDef>To Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.visible_until | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- Notice Info Column -->
      <ng-container matColumnDef="info">
        <th translate mat-header-cell *matHeaderCellDef>Notice Board Info</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="cursor_pointer"
          matTooltip="{{ element.description }}"
          matTooltipPosition="right"
          #tooltip="matTooltip"
          (click)="tooltip.toggle()"
        >
          {{ element.description | slice : 0 : 50
          }}{{ element.description.length > 100 ? "..." : "" }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th translate mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element.status }}
        </td>
      </ng-container>
      <ng-container matColumnDef="images">
        <th translate mat-header-cell *matHeaderCellDef>Images</th>
        <td mat-cell *matCellDef="let element">
          <img
            [src]="this.imagePath + '/' + element.image_url"
            alt="Notice Image"
            class="notice-image"
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th translate mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center">
            <button translate mat-button class="view_button" (click)="viewItem(element)">
              View
            </button>
            <div
              class="action_button"
              [matMenuTriggerFor]="menu"
              aria-label="Actions"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              class="update_button"
              *ngIf="editId !== element.id"
              (click)="editItem(element)"
            >
              <mat-icon>edit</mat-icon>
              <span translate>Edit</span>
            </button>
            <button
              mat-menu-item
              class="delete_button"
              (click)="deleteApi(element.id)"
            >
              <mat-icon>delete</mat-icon>
              <span translate>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        cdkDrag
        [cdkDragDisabled]="!reorderMode"
        [class.drag-disabled]="!reorderMode"
        [cdkDragStartDelay]="50"
      ></tr>
    </table>
  </div>
</section>
